export function toArray (array) {
  return Array.prototype.slice.call(array)
}
